import { AddPromotion } from './AddPromotion';
export default AddPromotion;
